import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';

import type { IconName } from '@core/user-interface-legacy';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-wysiwyg-inline-button',
  templateUrl: './wysiwyg-inline-button.component.html',
  styleUrls: ['./wysiwyg-inline-button.component.less'],
  host: {
    '(click)': '$event.preventDefault()',
    '[class.active]': 'active()',
    '[class.invalid]': 'status()?.invalid',
    '[class.dropdown-open]': 'dropdownOpen()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent],
})
export class WysiwygInlineButtonComponent {
  public readonly dropdownOpen = input<boolean>(undefined!);
  public readonly active = input<boolean>(undefined!);
  public readonly status = input<{
    invalid: boolean;
    message: string;
  }>(undefined!);

  public readonly clipboardValue = input<string>(undefined!);
  public readonly displayValue = input<string>(undefined!);
  @Input() public icon: IconName;
}
